<template>
    <div>
        <div v-if="isAdmin" class="row">
            <div v-for="status in sseStatuses" :key="status.id" class="col-md-4 col-6 mb-4">
                <status-component :status="status" :is-admin="isAdmin"></status-component>
            </div>
        </div>
        <div v-else class="row">
            <div v-for="status in statuses" :key="status.id" class="col-md-4 col-6 mb-4">
                <status-component :status="status" :is-admin="isAdmin"></status-component>
            </div>
        </div>
        <!-- <button @click="disconnect">disconnect</button>
    <button @click="startupConnection">connect</button> -->
    </div>
</template>

<script>
import StatusComponent from './StatusComponent.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
    name: 'StatusBody',
    components: { StatusComponent },
    props: { isAdmin: Boolean },
    data() {
        return {
            es: null,
        }
    },
    computed: {
        ...mapState(['statuses', 'sseStatuses']),
    },
    created() {
        this.startupConnection()
    },
    methods: {
        ...mapActions(['getStatuses']),
        ...mapMutations(['setSSE']),
        startupConnection() {
            if (this.isAdmin) {
                this.setupStream()
            } else {
                this.getStatuses()
            }
        },
        setupStream() {
            this.es = new EventSource('sse')
            const es = this.es
            es.addEventListener(
                'open',
                (e) => {
                    console.log('SSE OPENED!')
                },
                false
            )
            es.addEventListener(
                'message',
                (e) => {
                    const data = JSON.parse(e.data)
                    console.log('SSE CONECTED NOW')
                    this.setSSE(data)
                },
                false
            )
            es.addEventListener(
                'error',
                (e) => {
                    console.log('SSE ERROR')
                    console.dir(es.readyState, { depth: null })
                    if (es.readyState === EventSource.CLOSED) {
                        console.log('A stream was closed...')
                        setTimeout(() => {
                            this.startupConnection()
                            console.log('Retring connection...')
                        }, 5000)
                    } else if (es.readyState === EventSource.CONNECTING) {
                        console.log('Reconnecting a stream...')
                    }
                },
                false
            )
        },
        disconnect() {
            this.es.close()
        },
    },
}
</script>
